import { Store } from 'pinia'
import { nextTick } from 'vue'
import Router from 'vue-router'

interface StoreWithSelectedOption extends Store {
  setSelectedOption: (key: string, value: unknown) => void
  isDirty: (name: string) => boolean
}

export default {
  methods: {
    fromQueryParams(router: Router, store: StoreWithSelectedOption, key: string) {
      nextTick(() => {
        // If the store is dirty, it means that the user has already set the filter value using the UI
        // so we don't need to set it from the query params)
        if (store.isDirty(key)) return

        store.setSelectedOption(key, router.currentRoute.query[key])
      })
    },
  },
}
